import type { IconDefinition } from '../index.tsx';

export const iconTrash: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconTrash',
  icon: [
    16,
    16,
    [],
    '',
    'M1 2H4V0H12V2H15V4H1V2Z M13 6H3V16H13V6ZM9 9H7V13H9V9Z',
  ],
};
